import { Game, Player, Season, SeasonType, Stat } from "../client"
import { LEAGUE } from "./NBA"

export type FilterFormFields = "league" | "game" | "player" | "lastNGames" | "seasons" | "seasonType" | "oppTeam" | "statCategories" | "singleSeason" | "dateFrom" | "dateTo" | "dateRange" | "periods"

export interface GameSearchData {
    league: LEAGUE
    game: Game
    singleSeason: Season
    seasonType: SeasonType
    categories: Stat[]
    players: Player[]
    periods: number[]
}

export interface PlayerSearchData {
    league: LEAGUE
    player: Player
    lastNGames: string
    categories: Stat[]
    seasons: Season[]
    seasonType: SeasonType
    oppTeamId: string
    dateFrom: string
    dateTo: string
    periods: number[]
}

export interface SearchData {
    league: LEAGUE
    player: Player
    game: string
    lastNGames: string
    categories: Stat[]
    singleSeason: Season
    seasons: Season[]
    seasonType: SeasonType
    oppTeamId: string
    dateTo: Date
    dateFrom: Date
}

export const VideoSearchRanges = {
    [LEAGUE.NBA]: {
        "Regular Season":  ["2026-27", "2025-26", "2024-25", "2023-24", "2022-23", "2021-22", "2020-21", "2019-20", "2018-19", "2017-18", "2016-17", "2015-16", "2014-15"] as Season[],
        "Playoffs": ["2026-27", "2025-26", "2024-25", "2023-24", "2022-23", "2021-22", "2020-21", "2019-20", "2018-19", "2017-18", "2016-17", "2015-16", "2014-15"] as Season[],
    },
    [LEAGUE.WNBA]: {
        "Regular Season": ["2026", "2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015"] as Season[],
        "Playoffs": ["2026", "2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015"] as Season[],
    }
}

const getYearFromSeason = (s: Season): number => {
    return Number(s.split("-")[0])
}

export const getPlayerSeasons = (
    player: Player | null | undefined,
    seasons: Season[]
): Season[] => {
    if (!player) return seasons
    const { fromYear, toYear } = player

    if (fromYear == null && toYear == null) return seasons

    return seasons.filter((season) => {
        const year = getYearFromSeason(season)
        return (fromYear == null || year >= fromYear) &&
            (toYear == null || year <= toYear)
    })
}

export const filterPlayersWithVideos = (
    league: LEAGUE,
    players: Player[]
): Player[] => {
    const seasons = VideoSearchRanges[league]?.["Regular Season"] || []
    if (seasons.length === 0) return players

    const years = seasons.map(getYearFromSeason)
    const minYear = Math.min(...years)
    const maxYear = Math.max(...years)

    return players.filter((player) => {
        const { fromYear, toYear } = player
        if (fromYear == null && toYear == null) return true
        return (toYear == null || toYear >= minYear) &&
            (fromYear == null || fromYear <= maxYear)
    })
}